/* eslint-disable no-unused-vars */
import { Footer } from './Footer';
import * as S from './SettingsMain.styled';
import { FormProvider, useForm } from 'react-hook-form';
import { GeneralInformationSection } from 'components/accountSettings/sections/GeneralInformationSection';
import { CompanySection } from 'components/accountSettings/sections/CompanySection';
import { FinanceContactSection } from 'components/accountSettings/sections/FinanceContactSection';
import { SocialMediaSection } from 'components/accountSettings/sections/SocialMediaSection';
import { useSelector } from 'react-redux';
import { accountSettingsAPI } from 'services/accountSettings.service';
import { useEffect, useRef } from 'react';
import { showPolipop } from 'utils';
import { Loader } from 'components';
import { isPublisherRole } from 'store/selectors';

const SettingsMain = () => {
  const isPublisher = useSelector(isPublisherRole);
  const accountSettingsData = useSelector(
    (state) => accountSettingsAPI.endpoints.GetAccountSettingsData.select()(state)?.data,
  );
  const isNewEmail = useRef(false);

  // const [validateEmail, validResult] = accountSettingsAPI.useValidateNewEmailAddressMutation();
  const [saveAccountSettingsData, result] = accountSettingsAPI.useSaveAccountSettingsDataMutation();
  const methods = useForm({
    mode: 'onChange',
    reValidateMode: 'onBlur',
    defaultValues: accountSettingsData || {},
  });
  const {
    reset,
    getValues,
    formState: { isDirty, isValid, errors },
    trigger,
  } = methods;

  const successAction = () => {
    const currentState = getValues();
    if (isNewEmail.current) {
      currentState.generalInformation.email = accountSettingsData.generalInformation.email;
      isNewEmail.current = false;
    }

    reset(currentState, { keepDirty: false });
  };

  useEffect(() => {
    trigger();
  }, []);

  useEffect(() => {
    if (result.isSuccess || result.isError) {
      if (result?.data?.error?.invalidEmail) {
        alert('Please, enter valid email');
      } else if (result?.data?.error?.emailExist) {
        alert('Email already exists. Please, use another one');
        successAction();
        return;
      } else if (isNewEmail && result?.data?.activationEmailSent) {
        alert('Please check your email to confirm the email change');
      }
      showPolipop(result, successAction);
    }
  }, [result]);

  // submit handler
  const handleSubmit = async (data) => {
    const oldEmail = accountSettingsData.generalInformation.email;
    const newEmail = getValues('generalInformation.email');
    if (oldEmail !== newEmail) {
      isNewEmail.current = true;
    }

    const body = new FormData();
    const castData = { ...data };
    body.append('generalProfileImage', data.generalInformation.profileImage);
    body.append('companyProfileImage', data.companyInformation.profileImage);
    body.append('idOrCertificateImage', data.companyInformation.idOrCertificateImage);
    castData.generalInformation.profileImage = '';
    castData.companyInformation.profileImage = '';
    castData.companyInformation.idOrCertificateImage = '';

    // reset to false if some Advertisers has it saved to true in db
    if (!isPublisher && castData.generalInformation.additionalInfo)
      castData.generalInformation.additionalInfo.getNotifications = false;

    body.append('accountSettingsData', JSON.stringify(castData));
    saveAccountSettingsData(body);
  };

  return (
    <FormProvider {...methods}>
      {result.isLoading && <Loader.Global delay={0} />}
      <S.Form onSubmit={methods.handleSubmit(handleSubmit)}>
        {/* General Information Section */}
        <S.SectionContainer>
          <S.SectionName>General Information</S.SectionName>
          <GeneralInformationSection />
        </S.SectionContainer>
        {/* Company Information Section */}
        <S.SectionContainer>
          <S.SectionName>Company Information</S.SectionName>
          <CompanySection />
        </S.SectionContainer>

        {/* Finance Contact Details Section */}
        <S.SectionContainer>
          <S.SectionName>Finance Contact Details</S.SectionName>
          <FinanceContactSection />
        </S.SectionContainer>

        {/* Social Media Section */}
        <S.SectionContainer>
          <S.SectionName>Social Media</S.SectionName>
          <SocialMediaSection />
        </S.SectionContainer>

        {/* Footer with Submit Button */}
        <Footer />
      </S.Form>
    </FormProvider>
  );
};

export default SettingsMain;
